var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vacancy-details", { attrs: { vacancy: _vm.activeVacancy } }),
      _vm._v(" "),
      _c("vacancy-form", {
        attrs: {
          "job-position": _vm.activeVacancy.position,
          policy: _vm.policy,
          agreement: _vm.agreement,
          terms: _vm.terms,
          id: "formNew",
        },
        scopedSlots: _vm._u([
          {
            key: "description",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 col-lg-6 p-md-2 pr-6" },
                  [
                    _c("h2", { staticClass: "vacancy-form__h2 mb-10" }, [
                      _vm._v("Присоединяйтесь к нашей команде!"),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "vacancy-form__p" }, [
                      _vm._v("Отдел Карьеры "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "d-block vacancy-form__link",
                        attrs: { href: "tel:88005004373" },
                      },
                      [_vm._v("8 (800) 500-43-73")]
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }